/**
 *
 */
(function() {
	"use strict";

	angular.module("cbl.insuranceloanpmi.mf.directives").directive("creasIbanFormatter", ['CONSTANTS', function(CONSTANTS) {
		function linkFunc(scope, el, attr, ngModel) {
		    // For DOM -> model remove space
		    ngModel.$parsers.unshift(function (value) {
		      if (!value || value === '') {
		        return value;
		      }
		      value = String(value).replace(/ /g, '');
		      return value.slice(0, 27);
		    });
		 
		    // For model -> DOM convert decimal to comma
		    ngModel.$formatters.unshift(function (value) {
		      if (!value || value === '') {
		        return value;
		      }
		      // 2-2-1-5-5-12
		      // 2 - NAZIONE
		      if (value.length > 2 && value.charAt(2) !== ' ') {
		        value = value.substring(0, 2) + ' ' + value.substring(2);
		      }
		      // 2 - Controllo
		      if (value.length > 5 && value.charAt(5) !== ' ') {
		        value = value.substring(0, 5) + ' ' + value.substring(5);
		      }
		      // 1 - CIN
		      if (value.length > 7 && value.charAt(7) !== ' ') {
		        value = value.substring(0, 7) + ' ' + value.substring(7);
		      }
		      // 5 - ABI
		      if (value.length > 13 && value.charAt(13) !== ' ') {
		        value = value.substring(0, 13) + ' ' + value.substring(13);
		      }
		      // 5 - CAB
		      if (value.length > 19 && value.charAt(19) !== ' ') {
		        value = value.substring(0, 19) + ' ' + value.substring(19);
		      }
		      // 12 - Numero di conto corrente
		      if (value.length > 32) {
		        value = value.substring(0, 32);
		      }
		      return value;
		    });
		 
		    // Keyup or paste, don't use => need function defined for not isolated
			// "this"
		    el.bind('keyup paste', function change() {
		      if (!this.value || this.value === '') {
		        return;
		      }
		      // 2 - NAZIONE
		      if (this.value.length > 2 && this.value.charAt(2) !== ' ') {
		        this.value = this.value.substring(0, 2) + ' ' + this.value.substring(2);
		      }
		      // 2 - Controllo
		      if (this.value.length > 5 && this.value.charAt(5) !== ' ') {
		        this.value = this.value.substring(0, 5) + ' ' + this.value.substring(5);
		      }
		      // 1 - CIN
		      if (this.value.length > 7 && this.value.charAt(7) !== ' ') {
		        this.value = this.value.substring(0, 7) + ' ' + this.value.substring(7);
		      }
		      // 5 - ABI
		      if (this.value.length > 13 && this.value.charAt(13) !== ' ') {
		        this.value = this.value.substring(0, 13) + ' ' + this.value.substring(13);
		      }
		      // 5 - CAB
		      if (this.value.length > 19 && this.value.charAt(19) !== ' ') {
		        this.value = this.value.substring(0, 19) + ' ' + this.value.substring(19);
		      }
		      // 12 - Numero di conto corrente
		      if (this.value.length > 32) {
		        this.value = this.value.substring(0, 32);
		      }
		      this.value = this.value.trim();
		    });
		  }

		return {
			restrict: "A",
			require: '^ngModel',
		    link: linkFunc
		};
	}]);
}(window));


//////////////////
// WEBPACK FOOTER
// ./app/widgets/creasIbanFormatter/creasIbanFormatterDrct.js
// module id = 12
// module chunks = 0 1